/* eslint-disable */
import styles from './index.module.scss'
import Useful from '../../components/pages/useful'
import translate from '../../utils/translate.json'
import { PageContext } from '../../context/PageContextProvider'
import { useState, useContext, useEffect } from 'react'
import { Calculator, LangArrows, Info } from '../../icons'
import { GeneralInput } from '../../components/core/input'
import { Button } from '../../components/core/button'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'
import StepLine from '../../components/core/stepLine'
import { calculateOfficialPayroll } from './payrollCalculator2026'

const Calculator1 = ({ className }) => {
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [info, setInfo] = useState([])

  const [workplaceType, setWorkplaceType] = useState('MAIN') // 'MAIN' | 'ADDITIONAL'
  const [calcMode, setCalcMode] = useState('GROSS_TO_NET')
  const [salarySlider, setSalarySlider] = useState(1000) // 'GROSS_TO_NET' | 'NET_TO_GROSS'

  const sectorOptions = [
    {
      id: 'PRIVATE',
      name: {
        AZ: 'Qeyri-dövlət və qeyri-neft sektoru (Özəl)',
        ENG: 'Non-state & non-oil sector (Private)',
        RU: 'Негосударственный и ненефтяной сектор (Частный)',
        TR: 'Devlet dışı ve petrol dışı sektör (Özel)',
      }
    },
    {
      id: 'STATE',
      name: {
        AZ: 'Dövlət və neft-qaz sektoru',
        ENG: 'State & oil-gas sector',
        RU: 'Государственный и нефтегазовый сектор',
        TR: 'Devlet ve petrol-gaz sektörü',
      }
    }
  ]

  const exemptionOptions = [
    {
      amount: 0,
      label: {
        AZ: 'Güzəşt yoxdur (0 AZN)',
        ENG: 'No exemption (0 AZN)',
        RU: 'Без льготы (0 AZN)',
        TR: 'Muafiyet yok (0 AZN)',
      }
    },
    {
      amount: 800,
      label: {
        AZ: '800 AZN (Şəhid ailə üzvləri - Maddə 102.1-1)',
        ENG: '800 AZN (Martyrs family members - Art. 102.1-1)',
        RU: '800 AZN (Члены семей шехидов - Ст. 102.1-1)',
        TR: '800 AZN (Şehit aile fertleri - Madde 102.1-1)',
      }
    },
    {
      amount: 400,
      label: {
        AZ: '400 AZN (Milli Qəhrəman, Şəhid dul arvadı - Maddə 102.2)',
        ENG: '400 AZN (War heroes, Martyr widows - Art. 102.2)',
        RU: '400 AZN (Герои войны, вдовы шехидов - Ст. 102.2)',
        TR: '400 AZN (Milli Kahraman, Şehit eşi - Madde 102.2)',
      }
    },
    {
      amount: 200,
      label: {
        AZ: '200 AZN (I və II dərəcə əlillər, Müharibə iştirakçıları - Maddə 102.3)',
        ENG: '200 AZN (1st & 2nd degree disabled, Veterans - Art. 102.3)',
        RU: '200 AZN (Инвалиды I и II гр., Ветераны - Ст. 102.3)',
        TR: '200 AZN (I ve II derece engelliler, Gaziler - Madde 102.3)',
      }
    },
    {
      amount: 100,
      label: {
        AZ: '100 AZN (Çernobıl, Məcburi köçkünlər - Maddə 102.4)',
        ENG: '100 AZN (Chernobyl, IDPs - Art. 102.4)',
        RU: '100 AZN (Чернобыльцы, вынужденные переселенцы - Ст. 102.4)',
        TR: '100 AZN (Çernobil, Mecburi göçmenler - Madde 102.4)',
      }
    },
    {
      amount: 50,
      label: {
        AZ: '50 AZN (Himayəsində azı 3 nəfər olanlar - Maddə 102.5)',
        ENG: '50 AZN (At least 3 dependents - Art. 102.5)',
        RU: '50 AZN (Имеющие на иждивении не менее 3 человек - Ст. 102.5)',
        TR: '50 AZN (Bakmakla yükümlü olduğu en az 3 kişi - Madde 102.5)',
      }
    }
  ]

  const [selectedSector, setSelectedSector] = useState(sectorOptions[0])
  const [selectedExemption, setSelectedExemption] = useState(exemptionOptions[0])
  const [isVisible1, setIsVisible1] = useState(false)
  const [isVisible2, setIsVisible2] = useState(false)

  useEffect(() => {
    (async () => {
      try {
        const data1 = await PagesAPI.getMagazinePageInfo()
        setInfo(data1?.data || [])
      } catch (e) {}
      setLoad(true)
    })()
  }, [])

  const steps = [
    {
      title: translate.calculation_type,
      text: translate.make_your_choice,
    },
    {
      title: translate.basic_information,
      text: translate.enter_info,
    },
    {
      title: translate.result,
      text: translate.ready,
    },
  ]

  const Calculate = () => {
    const rawAmount = parseFloat(document.getElementById('calculator1-emek-haqqi')?.value) || 0
    const rawUnion = parseFloat(document.getElementById('calculator1-faiz')?.value) || 0

    if (rawAmount <= 0) {
      alert(language === 'AZ' ? 'Zəhmət olmasa əməkhaqqı məbləğini daxil edin' : language === 'RU' ? 'Пожалуйста, введите сумму зарплаты' : 'Please enter salary amount')
      return
    }

    const calcResult = calculateOfficialPayroll({
      amount: rawAmount,
      sector: selectedSector.id,
      workplaceType: workplaceType,
      unionFeePercent: rawUnion,
      exemptionAmount: selectedExemption.amount,
      year: 2026
    }, calcMode)

    // Store in sessionStorage for full details on result page
    const storageData = {
      ...calcResult,
      sectorName: selectedSector.name[language],
      workplaceType,
      calcMode,
      year: 2026
    }
    try {
      sessionStorage.setItem('payroll_result_2026', JSON.stringify(storageData))
    } catch (e) {
      console.warn('sessionStorage error', e)
    }

    const { gross, exemptionAmount, taxableIncome, incomeTax, dsmfEmployee, unemploymentEmployee, itsEmployee, unionFee, net, superGross } = calcResult
    window.location.href = `/useful/calculator/1/result/${gross}/${exemptionAmount}/${taxableIncome}/${incomeTax}/${dsmfEmployee}/${unemploymentEmployee}/${itsEmployee}/${unionFee}/${net}/${superGross}`
  }

  return load ? (
    <section className={`${styles.container} ${className}`}>
      <Useful search={false} />
      <div className={styles.stepline}>
        <StepLine active={1} data={steps} />
      </div>
      <h2>
        <Calculator />
        {translate.deductions[language]} (2026)
      </h2>

      {/* Workplace and Direction Switchers */}
      <div className={styles.topControls}>
        <div className={styles.workplaceTabs}>
          <button
            type="button"
            className={workplaceType === 'MAIN' ? styles.active : ''}
            onClick={() => setWorkplaceType('MAIN')}
          >
            {language === 'AZ' ? '🏢 Əsas İş Yeri (200 ₼ güzəştlə)' : language === 'RU' ? '🏢 Основное место работы (льгота 200 ₼)' : language === 'TR' ? '🏢 Asıl İş Yeri (200 ₼ muafiyetli)' : '🏢 Main Workplace (200 ₼ exemption)'}
          </button>
          <button
            type="button"
            className={workplaceType === 'ADDITIONAL' ? styles.active : ''}
            onClick={() => setWorkplaceType('ADDITIONAL')}
          >
            {language === 'AZ' ? '💼 Əlavə İş Yeri' : language === 'RU' ? '💼 Дополнительное место работы' : language === 'TR' ? '💼 Ek İş Yeri' : '💼 Additional Workplace'}
          </button>
        </div>

        <div className={styles.directionToggle}>
          <button
            type="button"
            className={calcMode === 'GROSS_TO_NET' ? styles.active : ''}
            onClick={() => setCalcMode('GROSS_TO_NET')}
          >
            Gross ➔ Net
          </button>
          <button
            type="button"
            className={calcMode === 'NET_TO_GROSS' ? styles.active : ''}
            onClick={() => setCalcMode('NET_TO_GROSS')}
          >
            Net ➔ Gross
          </button>
        </div>
      </div>

      <div className={styles.selects}>
        {/* Sector dropdown */}
        <div
          className={styles.select}
          onBlur={() => setTimeout(() => setIsVisible1(false), 250)}
        >
          <p>{translate.sector[language] || translate.sector.AZ}</p>
          <span tabIndex="1" onClick={() => setIsVisible1(!isVisible1)}>
            {selectedSector.name[language] || selectedSector.name.AZ} <LangArrows />
          </span>
          <ul style={{ display: isVisible1 ? 'block' : 'none' }}>
            {sectorOptions.map((sec) => (
              <li
                key={sec.id}
                onClick={() => {
                  setSelectedSector(sec)
                  setIsVisible1(false)
                }}
              >
                {sec.name[language] || sec.name.AZ}
              </li>
            ))}
          </ul>
        </div>

        {/* Salary Input with Interactive Range Slider & Presets */}
        <div className={styles.salaryInputWrap}>
          <GeneralInput
            id={'calculator1-emek-haqqi'}
            value={salarySlider}
            onChange={(e) => {
              const val = parseFloat(e.target.value) || 0;
              setSalarySlider(val);
            }}
            label={calcMode === 'GROSS_TO_NET' ? (language === 'AZ' ? 'Hesablanan Əməkhaqqı (Gross AZN)' : language === 'RU' ? 'Начисленная зарплата (Gross AZN)' : language === 'TR' ? 'Brüt Maaş (Gross AZN)' : 'Gross Salary (AZN)') : (language === 'AZ' ? 'Xalis Əməkhaqqı (Net AZN)' : language === 'RU' ? 'Чистая зарплата (Net AZN)' : language === 'TR' ? 'Net Maaş (Net AZN)' : 'Net Salary (AZN)')}
            placeholder={language === 'AZ' ? 'Məsələn: 1000' : language === 'RU' ? 'Например: 1000' : language === 'TR' ? 'Örneğin: 1000' : 'E.g.: 1000'}
          />

          <div className={styles.rangeSliderBox}>
            <input
              type="range"
              min="345"
              max="15000"
              step="50"
              value={salarySlider}
              onChange={(e) => {
                const val = parseFloat(e.target.value) || 345;
                setSalarySlider(val);
                const inp = document.getElementById('calculator1-emek-haqqi');
                if (inp) inp.value = val;
              }}
              className={styles.rangeSlider}
            />
            <div className={styles.sliderTicks}>
              <span>345 ₼</span>
              <span className={styles.activeVal}>{salarySlider.toLocaleString()} ₼</span>
              <span>15 000 ₼</span>
            </div>

            <div className={styles.presetChips}>
              {[500, 1000, 2500, 5000, 8000, 10000].map((preset) => (
                <button
                  key={preset}
                  type="button"
                  onClick={() => {
                    setSalarySlider(preset);
                    const inp = document.getElementById('calculator1-emek-haqqi');
                    if (inp) inp.value = preset;
                  }}
                  className={salarySlider === preset ? styles.activeChip : ''}
                >
                  {preset.toLocaleString()} ₼
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Union fee % */}
        <GeneralInput
          id={'calculator1-faiz'}
          label={language === 'AZ' ? 'Həmkarlar İttifaqı (%)' : language === 'RU' ? 'Профсоюзный взнос (%)' : language === 'TR' ? 'Sendika Kesintisi (%)' : 'Trade Union Fee (%)'}
          placeholder={'0%'}
        />

        {/* Concessions / Exemption Dropdown */}
        <div
          className={styles.select}
          onBlur={() => setTimeout(() => setIsVisible2(false), 250)}
        >
          <p>{translate.concessions[language] || translate.concessions.AZ}</p>
          <span tabIndex="1" onClick={() => setIsVisible2(!isVisible2)}>
            {selectedExemption.label[language] || selectedExemption.label.AZ} <LangArrows />
          </span>
          <ul style={{ display: isVisible2 ? 'block' : 'none' }}>
            {exemptionOptions.map((opt, oidx) => (
              <li
                key={oidx}
                onClick={() => {
                  setSelectedExemption(opt)
                  setIsVisible2(false)
                }}
              >
                {opt.label[language] || opt.label.AZ}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <Button
        click={() => Calculate()}
        to={'#'}
      >
        {translate.hesabla[language] || translate.hesabla.AZ}
      </Button>

      {/* Algorithm description (2026 rules) */}
      <h2>
        <Info />
        {translate.algorithm[language] || translate.algorithm.AZ} ({language === 'AZ' ? '2026 Standartları' : language === 'RU' ? 'Стандарты 2026 года' : language === 'TR' ? '2026 Standartları' : '2026 Standards'})
      </h2>

      <div className={styles.algorithmCard}>
        <div className={styles.algoCol}>
          <h4>
            {language === 'AZ' ? '🏢 Qeyri-Dövlət və Qeyri-Neft Sektoru (2026)' :
             language === 'RU' ? '🏢 Частный и ненефтяной сектор (2026)' :
             language === 'TR' ? '🏢 Özel ve Petrol Dışı Sektör (2026)' :
             '🏢 Non-State & Non-Oil Sector (2026)'}
          </h4>
          <ul>
            <li>
              <strong>{language === 'AZ' ? 'Gəlir Vergisi:' : language === 'RU' ? 'Подоходный налог:' : language === 'TR' ? 'Gelir Vergisi:' : 'Income Tax:'}</strong>{' '}
              {language === 'AZ' ? '2500 ₼-dək gəlirdən 3%; 2500–8000 ₼ arası məbləğdən 75 ₼ + 10%; 8000 ₼-dən çox olduqda 625 ₼ + 14%.' :
               language === 'RU' ? 'До 2500 ₼ — 3%; от 2500 до 8000 ₼ — 75 ₼ + 10%; свыше 8000 ₼ — 625 ₼ + 14%.' :
               language === 'TR' ? '2500 ₼\'ye kadar %3; 2500–8000 ₼ arası 75 ₼ + %10; 8000 ₼ üzeri 625 ₼ + %14.' :
               'Up to 2500 ₼ — 3%; 2500–8000 ₼ — 75 ₼ + 10%; over 8000 ₼ — 625 ₼ + 14%.'}
            </li>
            <li>
              <strong>{language === 'AZ' ? 'DSMF (İşçi):' : language === 'RU' ? 'Соцстрах (Работник):' : language === 'TR' ? 'Sosyal Güvenlik (Çalışan):' : 'Social Security (Employee):'}</strong>{' '}
              {language === 'AZ' ? '200 ₼-dək 3%; 200 ₼-dən çox olduqda 6 ₼ + 10%.' :
               language === 'RU' ? 'До 200 ₼ — 3%; свыше 200 ₼ — 6 ₼ + 10%.' :
               language === 'TR' ? '200 ₼\'ye kadar %3; 200 ₼ üzeri 6 ₼ + %10.' :
               'Up to 200 ₼ — 3%; over 200 ₼ — 6 ₼ + 10%.'}
            </li>
            <li>
              <strong>{language === 'AZ' ? 'İcbari Tibbi Sığorta (İşçi & İşəgötürən):' : language === 'RU' ? 'Медстрахование (Работник и Работодатель):' : language === 'TR' ? 'Sağlık Sigortası (Çalışan ve İşveren):' : 'Health Insurance (Employee & Employer):'}</strong>{' '}
              {language === 'AZ' ? '2500 ₼-dək 2%; 2500 ₼-dən çox olduqda 50 ₼ + 0.5%.' :
               language === 'RU' ? 'До 2500 ₼ — 2%; свыше 2500 ₼ — 50 ₼ + 0.5%.' :
               language === 'TR' ? '2500 ₼\'ye kadar %2; 2500 ₼ üzeri 50 ₼ + %0.5.' :
               'Up to 2500 ₼ — 2%; over 2500 ₼ — 50 ₼ + 0.5%.'}
            </li>
            <li>
              <strong>{language === 'AZ' ? 'İşsizlikdən Sığorta:' : language === 'RU' ? 'Страхование от безработицы:' : language === 'TR' ? 'İşsizlik Sigortası:' : 'Unemployment Insurance:'}</strong>{' '}
              {language === 'AZ' ? 'İşçi və İşəgötürən hər biri 0.5%.' :
               language === 'RU' ? 'Работник и работодатель — по 0.5%.' :
               language === 'TR' ? 'Çalışan ve İşveren her biri %0.5.' :
               'Employee and Employer 0.5% each.'}
            </li>
            <li>
              <strong>{language === 'AZ' ? 'İşəgötürən DSMF:' : language === 'RU' ? 'Соцстрах (Работодатель):' : language === 'TR' ? 'İşveren Sosyal Güvenlik Payı:' : 'Employer Social Security:'}</strong>{' '}
              {language === 'AZ' ? '200 ₼-dək 22%; 200–8000 ₼ arası 44 ₼ + 15%; 8000 ₼-dən çox hissəyə 11%.' :
               language === 'RU' ? 'До 200 ₼ — 22%; 200–8000 ₼ — 44 ₼ + 15%; свыше 8000 ₼ — 11%.' :
               language === 'TR' ? '200 ₼\'ye kadar %22; 200–8000 ₼ arası 44 ₼ + %15; 8000 ₼ üzeri %11.' :
               'Up to 200 ₼ — 22%; 200–8000 ₼ — 44 ₼ + 15%; over 8000 ₼ — 11%.'}
            </li>
            <li>
              <strong>{language === 'AZ' ? 'Baza Güzəşti:' : language === 'RU' ? 'Базовая льгота:' : language === 'TR' ? 'Temel Muafiyet:' : 'Basic Exemption:'}</strong>{' '}
              {language === 'AZ' ? '200 ₼ baza güzəşti yalnız Əsas iş yerində tətbiq olunur.' :
               language === 'RU' ? 'Базовая льгота 200 ₼ применяется только по основному месту работы.' :
               language === 'TR' ? '200 ₼ temel muafiyet yalnızca Asıl iş yerinde uygulanır.' :
               '200 ₼ basic exemption is applied only at the Main workplace.'}
            </li>
          </ul>
        </div>

        <div className={styles.algoCol}>
          <h4>
            {language === 'AZ' ? '🏛️ Dövlət və Neft-Qaz Sektoru (Standart)' :
             language === 'RU' ? '🏛️ Государственный и нефтегазовый сектор' :
             language === 'TR' ? '🏛️ Devlet ve Petrol-Gaz Sektörü (Standart)' :
             '🏛️ State & Oil-Gas Sector (Standard)'}
          </h4>
          <ul>
            <li>
              <strong>{language === 'AZ' ? 'Gəlir Vergisi:' : language === 'RU' ? 'Подоходный налог:' : language === 'TR' ? 'Gelir Vergisi:' : 'Income Tax:'}</strong>{' '}
              {language === 'AZ' ? '2500 ₼-dək vergiyə cəlb olunan hissədən 14%; 2500 ₼-dən yuxarı hissədən 350 ₼ + 25%.' :
               language === 'RU' ? 'До 2500 ₼ — 14%; свыше 2500 ₼ — 350 ₼ + 25%.' :
               language === 'TR' ? '2500 ₼\'ye kadar vergiye tabi tutardan %14; 2500 ₼ üzeri tutardan 350 ₼ + %25.' :
               'Up to 2500 ₼ — 14%; over 2500 ₼ — 350 ₼ + 25%.'}
            </li>
            <li>
              <strong>{language === 'AZ' ? 'DSMF:' : language === 'RU' ? 'Соцстрах:' : language === 'TR' ? 'Sosyal Güvenlik:' : 'Social Security:'}</strong>{' '}
              {language === 'AZ' ? 'İşçi 3%, İşəgötürən 22% (bütün məbləğdən).' :
               language === 'RU' ? 'Работник 3%, Работодатель 22% (со всей суммы).' :
               language === 'TR' ? 'Çalışan %3, İşveren %22 (tüm tutar üzerinden).' :
               'Employee 3%, Employer 22% (from entire amount).'}
            </li>
            <li>
              <strong>{language === 'AZ' ? 'İcbari Tibbi Sığorta:' : language === 'RU' ? 'Медстрахование:' : language === 'TR' ? 'Sağlık Sigortası:' : 'Health Insurance:'}</strong>{' '}
              {language === 'AZ' ? '8000 ₼-dək 2%; 8000 ₼-dən çox hissəyə 0.5%.' :
               language === 'RU' ? 'До 8000 ₼ — 2%; свыше 8000 ₼ — 0.5%.' :
               language === 'TR' ? '8000 ₼\'ye kadar %2; 8000 ₼ üzeri tutardan %0.5.' :
               'Up to 8000 ₼ — 2%; over 8000 ₼ — 0.5%.'}
            </li>
            <li>
              <strong>{language === 'AZ' ? 'İşsizlikdən Sığorta:' : language === 'RU' ? 'Страхование от безработицы:' : language === 'TR' ? 'İşsizlik Sigortası:' : 'Unemployment Insurance:'}</strong>{' '}
              {language === 'AZ' ? 'Hər iki tərəf üçün 0.5%.' :
               language === 'RU' ? 'Для обеих сторон — по 0.5%.' :
               language === 'TR' ? 'Her iki taraf için de %0.5.' :
               '0.5% for both parties.'}
            </li>
            <li>
              <strong>Super Gross:</strong>{' '}
              {language === 'AZ' ? 'İşəgötürənin ödəməli olduğu ümumi xərc (Gross + İşəgötürən DSMF, İTS və İşsizlik).' :
               language === 'RU' ? 'Общие расходы работодателя (Gross + Соцстрах, Медстрах и Безработица).' :
               language === 'TR' ? 'İşverenin toplam maliyeti (Brüt + İşveren SGK, Sağlık ve İşsizlik payı).' :
               'Total cost to employer (Gross + Employer Social Security, Health & Unemployment).'}
            </li>
          </ul>
        </div>
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default Calculator1
